<ng-template #sectionHeader let-key="key" let-title="title">
  <button type="button" class="section-header" (click)="toggleSection(key)" [attr.aria-expanded]="isSectionOpen(key)" [attr.aria-controls]="'node-section-' + key" [attr.data-testid]="'node-section-' + key">
    <mat-icon>{{isSectionOpen(key)?'expand_less':'expand_more'}}</mat-icon>
    <span>{{title}}</span>
  </button>
</ng-template>

@if (linqset && nodes && nodes.length>0) {
  <div class="properties-container">
    @if (linqsetNode && !(nodeNames && nodeNames.length > 1)) {
      <div class="node-heading" data-testid="node-heading">
        <app-node-svg [type]="linqsetNode.type"/>
        <h2>{{linqsetNode.name || 'Unnamed node'}}</h2>
      </div>
    }
    <form [formGroup]="nodeGroupForm">
      @if (nodeNames && nodeNames.length > 1) {
        <h4>{{getMultipleSelectionMessage()}}</h4>
        @for (n of nodeNames; track n._key) {
            <section><app-node-svg [type]="n.type"/>{{n.name}}</section>
        }
      }
      @if (linqset?.isOrganisationModel() && selectedNode && (!linqsetNode || linqsetNode._key !== selectedNode._key)) {
        @if (linqset.isDirty()) {
          <span>Merge unavailable because there are unsaved changes. Save and try again.</span>
          }@else {
          <button mat-button (click)="mergeNodes()" color="accent">Click here to merge the selected nodes into the following node</button>
        }
      }

      <ng-container *ngTemplateOutlet="sectionHeader; context: {key: 'details', title: 'Details'}"></ng-container>
      @if (isSectionOpen('details')) {
        <div class="section-body" id="node-section-details">
          @if (superType === NODE_SUPERTYPE.INFORMATION) {
            <section>
              <button mat-button matTooltip="Edit this information asset" aria-label="Edit selected information asset" color="accent" (click)="openInformationAssetDialog(true)" [disabled]="readonly || !currentInformationAsset">
                  Edit asset
                </button>
                <button mat-button matTooltip="Add information asset" aria-label="Add new information asset" color="accent" (click)="openInformationAssetDialog(false)" [disabled]="readonly">
                  New asset
              </button>

              <mat-form-field>
                <mat-label>Information asset</mat-label>
                <input type="text"
                  placeholder="Select information asset"
                  aria-label="Information asset"
                  matInput
                  [formControl]="informationAssetControl"
                  [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option [value]="undefined" (onSelectionChange)="handleChange('informationAssetKey', undefined)">-- No asset --</mat-option>

                    @for (asset of filteredInformationAssets | async; track asset._key) {
                      <mat-option [value]="asset.name" (onSelectionChange)="handleChange('informationAssetKey', asset)">{{asset.name}}</mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </section>
            }

            @if (showNodeSelection) {
                @if (!linqsetNode) {
                    <p>Multiple nodes selected, cannot change name. Selecting an existing node will change selected instances to selected node</p>
                }
                <app-select-node [nodes]="existingNodes" [inputNode]="linqsetNode" (selectedNodeChange)="onSelectedNodeChange($event)"></app-select-node>
            }

            @if (linqsetNode) {
                @if (!showNodeSelection) {
                    <mat-form-field (color)="linqsetNode.name?'accent':'warn'">
                        <mat-label>Name</mat-label>
                        <input matInput type="text" required="true" formControlName="name" [minlength]="NODE_NAME_MIN" [maxlength]="NODE_NAME_MAX" [size]="NODE_NAME_MAX">
                        @if (nodeGroupForm.controls['name'].hasError('maxLength') || nodeGroupForm.controls['name'].hasError('required')) {
                            <mat-error>{{getNameError()}}</mat-error>
                        }@else if (nodeGroupForm.controls['name'].hasError('noExistingName')) {
                            <mat-error>There is an existing node with this name</mat-error>
                    }
                    </mat-form-field>
                }
              <mat-form-field color="accent">
                <mat-label>Description</mat-label>
                <textarea matInput
                  formControlName="description"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="3"
                [maxLength]="NODE_DESCRIPTION_MAX"></textarea>
              </mat-form-field>
              <mat-form-field color="accent">
                <mat-label>URL</mat-label>
                <input matInput type="url" formControlName="url" [maxlength]="NODE_URL_MAX" [size]="NODE_URL_MAX">
              </mat-form-field>
              <mat-form-field color="accent">
                <mat-label>Type</mat-label>
                <mat-select formControlName="type">
                    <mat-select-trigger>
                        {{getNodeTypeName()}}
                    </mat-select-trigger>

                  @for (t of types; track t) {
                    <mat-option [value]="t.type">
                      <section>
                        <app-node-svg [type]="t.type"></app-node-svg>
                        <span>{{t.name}}</span>
                      </section>
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }

            @if (linqsetNode) {
              <mat-form-field>
                <mat-label>Notes</mat-label>
                <textarea matInput
                  formControlName="notes"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="5"
                [maxLength]="NODE_NOTES_MAX"></textarea>
              </mat-form-field>
              @if (linqsetNode.type === NODE_TYPE.TODO) {
                <mat-form-field appearance="fill" [style.margin-top.px]=20 color="accent">
                  <mat-label>Attention of</mat-label>
                  <mat-select multiple formControlName="userKeys" onchange="$event.stop">
                    @for (user of users; track user) {
                      <mat-option [value]="user._key">
                        {{user.name}}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            }

            @if (superType === NODE_SUPERTYPE.INFORMATION && heldAsReadHelp) {
              <p class="held-as-read" data-testid="held-as-read">{{ heldAsReadHelp }}</p>
            }
            @if (superType === NODE_SUPERTYPE.INFORMATION) {
              <mat-slide-toggle style="padding-top: 10px;padding-bottom: 20px;" labelPosition="after" formControlName="external">Connect node to other models</mat-slide-toggle>
            }

            @if (superType===NODE_SUPERTYPE.ACTION) {
              <mat-form-field appearance="fill" [style.margin-top.px]=20 color="accent" subscriptSizing="dynamic">
                <mat-label>Tags</mat-label>
                <mat-select multiple formControlName="tagKeys" onchange="$event.stop">
                  @for (group of getTagGroups(); track group) {
                    <mat-optgroup [label]="group.name">
                      @for (tag of group.tags; track tag) {
                        <mat-option [value]="tag._key">
                          {{tag.name}}
                        </mat-option>
                      }
                    </mat-optgroup>
                  }
                </mat-select>
                <mat-hint>Tags are used to categorise nodes.</mat-hint>
              </mat-form-field>
            }
            @if (superType === NODE_SUPERTYPE.SYSTEM && linqsetNode) {
              <!-- what part the system plays in keeping information, for the EPM scorecard's information risk -->
              <mat-form-field color="accent" subscriptSizing="dynamic">
                <mat-label>Kind of system</mat-label>
                <mat-select [ngModel]="nodeProperties.systemKind || ''" (ngModelChange)="handleChange('systemKind', $event || null)" [ngModelOptions]="{standalone: true}" [disabled]="readonly" data-testid="system-kind">
                  <mat-option value="">As LINQ reads it: {{ systemKindLabels[suggestedSystemKind].toLowerCase() }}</mat-option>
                  @for (k of systemKinds; track k) {<mat-option [value]="k">{{ systemKindLabels[k] }}</mat-option>}
                </mat-select>
                <mat-hint>{{ systemKindHelp }}</mat-hint>
              </mat-form-field>
            }
        </div>
      }

      @if ((superType===NODE_SUPERTYPE.ROLE || superType===NODE_SUPERTYPE.PEOPLE) && linqsetNode?.type !== NODE_TYPE.EXTERNAL_ORGANISATION) {
        <ng-container *ngTemplateOutlet="sectionHeader; context: {key: 'frequency', title: 'Capacity'}"></ng-container>
        @if (isSectionOpen('frequency')) {
          <div class="section-body" id="node-section-frequency">
            <!-- a role with people nodes takes its number of people from them -->
            @if ((isTeam() || superType===NODE_SUPERTYPE.ROLE) && canEditCosts) {
                <mat-form-field>
                    <mat-label>Number of people</mat-label>
                    <input matInput class="example-right-align" [ngModel]="nodeProperties.people||1" type="number" (ngModelChange)="handleChange('people', $event)" [ngModelOptions]="{standalone: true}" [disabled]="readonly">
                </mat-form-field>
            }
            <button mat-button matTooltip="Edit capacity of each person" aria-label="Edit capacity of this role or person" [style]="tempo.colour" (click)="openTempoDialog()" [disabled]="readonly || !canEditCapacity">
              {{tempo.message}}.
            </button>
          </div>
        }
      }

      @if (superType===NODE_SUPERTYPE.ACTION || superType===NODE_SUPERTYPE.OUTCOMES) {
        <ng-container *ngTemplateOutlet="sectionHeader; context: {key: 'frequency', title: 'Frequency'}"></ng-container>
        @if (isSectionOpen('frequency')) {
          <div class="section-body" id="node-section-frequency">
            @if (usesCalculatedFrequency()) {
              <mat-form-field color="accent" subscriptSizing="dynamic">
                <mat-label>Information processing</mat-label>
                <mat-select formControlName="actionProcessType">
                  <mat-option [value]="ACTION_FREQUENCY_TYPE.SUM">Take sum of information inputs</mat-option>
                  <mat-option [value]="ACTION_FREQUENCY_TYPE.MAXIMUM">Take the greatest information input</mat-option>
                  <mat-option [value]="ACTION_FREQUENCY_TYPE.MINIMUM">Take the least information input</mat-option>
                  <mat-option [value]="ACTION_FREQUENCY_TYPE.AVERAGE">Take average of information inputs</mat-option>
                </mat-select>
                <mat-hint>{{processTypeHelp}}</mat-hint>
              </mat-form-field>
            }
            @if (linqsetNode?.superType === NODE_SUPERTYPE.ACTION) {
              <mat-form-field color="accent" subscriptSizing="dynamic">
                <mat-label>Kind of work</mat-label>
                <mat-select [ngModel]="nodeProperties.workType === WORK_TYPE.NORMAL ? WORK_TYPE.VALUE_ADDING : nodeProperties.workType || ''" (ngModelChange)="handleChange('workType', $event || null)" [ngModelOptions]="{standalone: true}" [disabled]="readonly" data-testid="work-type">
                  <mat-option value="">As LINQ reads it: {{linqReadsWorkAs}}</mat-option>
                  <mat-option [value]="WORK_TYPE.VALUE_ADDING">Value adding</mat-option>
                  <mat-option [value]="WORK_TYPE.NECESSARY">Necessary</mat-option>
                  <mat-option [value]="WORK_TYPE.EXCEPTION">Exception</mat-option>
                  <mat-option [value]="WORK_TYPE.NOT_VALUE_ADDING">Not value adding</mat-option>
                  <mat-option [value]="WORK_TYPE.WAITING">Waiting</mat-option>
                </mat-select>
                <mat-hint>{{workTypeHelp}}</mat-hint>
              </mat-form-field>
            }
            <button mat-button class="tempo-link" matTooltip="Edit frequency and duration" aria-label="Edit frequency and duration" [style]="tempo.colour" (click)="openTempoDialog()" [disabled]="readonly">
              {{tempo.message}}
            </button>
          </div>
        }
      }
    </form>

    @if (canEditCosts) {
      <ng-container *ngTemplateOutlet="sectionHeader; context: {key: 'costs', title: 'Costs'}"></ng-container>
      @if (isSectionOpen('costs')) {
        <div class="section-body" id="node-section-costs">
            @if (linqsetNode?.type !== NODE_TYPE.EXTERNAL_ORGANISATION) {
                <mat-form-field subscriptSizing="dynamic">
                    <mat-label>Percentage modelled</mat-label>
                    <span matTextPrefix>%&nbsp;</span>
                    <input matInput class="example-right-align" [ngModel]="nodeProperties.percentageModelled" type="number" placeholder="100" (ngModelChange)="handleChange('percentageModelled', $event)" [disabled]="readonly" min="0" max="100">
                    <mat-hint>Estimate % of role activity modelled in LINQ</mat-hint>
                </mat-form-field>
            }
            @if (superType === NODE_SUPERTYPE.INFRASTRUCTURE) {
                <mat-form-field subscriptSizing="dynamic">
                <span matTextPrefix>years</span>
                    <mat-label>Lifespan</mat-label>
                    <input matInput class="example-right-align" [ngModel]="nodeProperties.lifetime" type="number" placeholder="1" (ngModelChange)="handleChange('lifetime', $event)" [disabled]="readonly" min="1" max="100">
                    <mat-hint>Lifespan in years. Used for scope 3 emissions.</mat-hint>
                </mat-form-field>
            }

            @if (superType === NODE_SUPERTYPE.INFRASTRUCTURE) {
                <mat-form-field>
                  <mat-label>Number of units</mat-label>
                  <input matInput class="example-right-align" [ngModel]="nodeProperties.units" type="number" (ngModelChange)="handleChange('units', $event)" [disabled]="readonly">
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Annual cost per unit</mat-label>
                  <span matTextPrefix>$&nbsp;</span>
                  <input matInput class="example-right-align" [ngModel]="nodeProperties.unitCost" placeholder="0" type="decimal" (ngModelChange)="handleChange('unitCost', $event)" [disabled]="readonly">
                </mat-form-field>
            }
            <!-- an external organisation has no capacity section, so its number of people stays with its costs -->
            @if (linqsetNode?.type === NODE_TYPE.EXTERNAL_ORGANISATION) {
                <mat-form-field>
                    <mat-label>Number of people</mat-label>
                    <input matInput class="example-right-align" [ngModel]="nodeProperties.people||1" type="number" (ngModelChange)="handleChange('people', $event)" [disabled]="readonly">
                </mat-form-field>
            }
            <mat-form-field>
                <mat-label>Annual cost per person</mat-label>
                <span matTextPrefix>$&nbsp;</span>
                <input matInput class="example-right-align" [ngModel]="nodeProperties.annualCost" placeholder="0" type="decimal" (ngModelChange)="handleChange('annualCost', $event)" [disabled]="readonly">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Hourly cost</mat-label>
                <span matTextPrefix>$&nbsp;</span>
                <input matInput class="example-right-align" [ngModel]="nodeProperties.hourlyCost" placeholder="0" type="number" (ngModelChange)="handleChange('hourlyCost', $event)" [disabled]="readonly">
              </mat-form-field>

            @if (superType===NODE_SUPERTYPE.SYSTEM || superType===NODE_SUPERTYPE.INFRASTRUCTURE) {
              <mat-form-field>
                <mat-label>Fixed annual cost</mat-label>
                <span matTextPrefix>$&nbsp;</span>
                <input matInput class="example-right-align" [ngModel]="nodeProperties.fixedCost" placeholder="0" type="decimal" (ngModelChange)="handleChange('fixedCost', $event)" [disabled]="readonly">
              </mat-form-field>
            }
        </div>
      }
    }

    @if (superType===NODE_SUPERTYPE.INFRASTRUCTURE) {
      <ng-container *ngTemplateOutlet="sectionHeader; context: {key: 'carbon', title: 'Carbon'}"></ng-container>
      @if (isSectionOpen('carbon')) {
        <div class="section-body" id="node-section-carbon">
            @if (!readonly) {
              <button mat-button color="accent" (click)="openEmissionsDialog()">
                Add emissions
              </button>
            }
            @if (getEmissionScopes().length===0) {
              <p>No emissions set. Add emissions using button above.</p>
              }@else {
              @for (scope of getEmissionScopes(); track scope) {
                <h4>{{emissionsMap[scope][0].label}}</h4>
                @for (emission of emissionsMap[scope]; track emission.emissions._key) {
                  <span class="controls-container">
                    <button mat-button color="accent" (click)="openEmissionsDialog(emission.emissions)" [disabled]="readonly">
                      <span [innerHTML]="emission.description"></span>
                    </button>
                    @if (!readonly) {
                      <button mat-icon-button color="warn" (click)="deleteEmissions(emission.emissions)" [disabled]="readonly">
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  </span>
                }
              }
            }
        </div>
      }
    }

    @if (linqsetNode && ((linqsetNode.superType === NODE_SUPERTYPE.INFORMATION && insights.isOutput) || linqsetNode.superType === NODE_SUPERTYPE.OUTCOMES)) {
      <ng-container *ngTemplateOutlet="sectionHeader; context: {key: 'outputs', title: 'Outputs'}"></ng-container>
      @if (isSectionOpen('outputs')) {
        <div class="section-body" id="node-section-outputs">
          @if (insights.joinedOut) {
            <p data-testid="joined-output">This output is joined into {{joinedModelNames}}. What it's worth is realised there, so it has no value or revenue of its own: it takes the value and revenue of the outputs it leads to in {{joinedModelCount === 1 ? 'that model' : 'those models'}}.</p>
            @if (insights.originValue || insights.originRevenue) {
              <p class="joined-figures">From the models it feeds: a value of <b>{{insights.originValue | number:'1.0-0'}}</b>@if (insights.originRevenue) { and revenue of <b>{{currencySymbol}}{{insights.originRevenue | number:'1.0-0'}}</b>} a year.</p>
            }
            @if (nodeProperties.outputValue || nodeProperties.outputRevenue) {
              <p class="joined-value-set" data-testid="joined-value-set">
                <mat-icon aria-hidden="true">warning</mat-icon>
                <span>A value per item of {{nodeProperties.outputValue || 0}} and revenue per item of {{currencySymbol}}{{nodeProperties.outputRevenue || 0}} are set here. They aren't counted now it's joined: set them on the outputs of the models it feeds.
                  @if (!readonly) {<button mat-stroked-button color="accent" type="button" (click)="clearJoinedValue()" data-testid="clear-joined-value">Clear them</button>}
                </span>
              </p>
            }
          } @else {
            <p>This is an output. You can assign an output value to indicate the relative value of each item produced and/or enter the amount of REVENUE each item is worth.</p>
            @if (linqsetNode.superType === NODE_SUPERTYPE.OUTCOMES) {
              <p>Any value/revenue entered here will be added onto any value/revenue that has been set on connected output nodes.</p>
            }
            @if (linqsetNode.external) {
              <p>Any numbers entered here will be added onto any value or revenue from other connected models.</p>
            }
          <mat-form-field (color)="linqsetNode.name?'accent':'warn'" subscriptSizing="dynamic">
            <mat-label>Output value per item</mat-label>
            <input matInput class="example-right-align" [ngModel]="nodeProperties.outputValue" type="number" (ngModelChange)="handleOutputValueChange($event)" [disabled]="readonly" min="0">
            @if (nodeProperties.outputValueSource) {
              <mat-hint>{{nodeProperties.outputValueSource === 'ai' ? 'Suggested by AI' : 'Derived by LINQ from how the output is used'}}</mat-hint>
            }
          </mat-form-field>
          @if (linqsetNode.superType === NODE_SUPERTYPE.INFORMATION && insights?.derivedValue > 0) {
            <p class="derived-value" data-testid="derived-value">
              LINQ derives a value of <b>{{insights.derivedValue}}</b> out of 100 for each item from how it is used: {{derivedValueReasons}}.
              @if (!readonly && nodeProperties.outputValue !== insights.derivedValue) {
                <button mat-stroked-button color="accent" type="button" class="use-derived-value" (click)="useDerivedValue()" data-testid="use-derived-value">Use as the output value</button>
              }
            </p>
          }
          <mat-form-field (color)="linqsetNode.name?'accent':'warn'">
            <mat-label>Output revenue per item</mat-label>
            <span matTextPrefix>$&nbsp; per item</span>
            <input matInput class="example-right-align" [ngModel]="nodeProperties.outputRevenue" type="number" (ngModelChange)="handleChange('outputRevenue', $event)" [disabled]="readonly">
          </mat-form-field>
          }
        </div>
      }
    }

    @if (linqsetNode && edgesOut.length > 0) {
      <ng-container *ngTemplateOutlet="sectionHeader; context: {key: 'flows', title: linqsetNode.superType === NODE_SUPERTYPE.PEOPLE?'Roles':'Information passed on'}"></ng-container>
      @if (isSectionOpen('flows')) {
        <div class="section-body" id="node-section-flows">
            @if (linqsetNode.superType === NODE_SUPERTYPE.PEOPLE) {
                <p>Set the percentage of modelled capacity spent on each role</p>
            }@else if (linqsetNode.superType === NODE_SUPERTYPE.INFORMATION || linqsetNode.superType === NODE_SUPERTYPE.ACTION) {
                <p>Set number of items passed on</p>
            }

            @for (e of edgesOut; track e) {
                <section>
                <mat-form-field style="width:48%;">
                    <mat-label>{{linqset.getNode(e.targetKey).name}}</mat-label>
                    <input matInput type="number" required="true" [(ngModel)]="e.outputPercentage" (change)="onOutputPercentageChange(e)" [disabled]="edgesReadonly">
                    <span matSuffix style="padding-right:10px;padding-top: 5px;">%</span>
                </mat-form-field>
                <mat-form-field style="width:48%;">
                    @if (linqsetNode.superType === NODE_SUPERTYPE.PEOPLE) {
                    <mat-label>Capacity allocated</mat-label>
                    }@else {
                    <mat-label>Number processed</mat-label>
                    }
                    <input matInput type="number" [ngModel]="getOutputNumber(e.outputPercentage)" [disabled]="true">
                    <span matSuffix style="padding-right:10px;padding-top: 5px;">{{linqsetNode.superType === NODE_SUPERTYPE.PEOPLE?'hours':''}}</span>
                </mat-form-field>
                </section>
            }
        </div>
      }
    }

    @if (linqsetNode && linqsetNode.superType !== NODE_SUPERTYPE.NOTES) {
      <ng-container *ngTemplateOutlet="sectionHeader; context: {key: 'insights', title: 'Insights'}"></ng-container>
      @if (isSectionOpen('insights')) {
        <div class="section-body" id="node-section-insights">
          @if (linqsetNode && models && models.length > 0) {
            <mat-form-field color="accent">
              <mat-label>View model insights for</mat-label>
              <mat-select [(ngModel)]="tileInsights" (selectionChange)="selectModel($event)">
                <mat-select-trigger>
                  {{tileInsights && tileInsights.selectedName}}
                </mat-select-trigger>
                @for (group of models; track group.name) {
                  <mat-optgroup [label]="group.name">
                    @for (model of group.models; track model._key) {
                      <mat-option [value]="model">{{model.name}}</mat-option>
                    }
                  </mat-optgroup>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (invalidInsightsMessage) {
            <p>{{invalidInsightsMessage}}</p>
            }@else {
            @if (cards && cards.length>0) {
              <app-insight-cards [cards]="cards"></app-insight-cards>
            }
          }
        </div>
      }
    }
  </div>
}@else {
  <p>No nodes selected</p>
}
